import {RedirectProvider} from "../../../../../../../api/generated";
import {SelectOption} from "../../../../../../elements/select/SelectDropdown";

export const allRedirectProviderOptions: SelectOption<RedirectProvider>[] = [
    {
        label: "No Redirect",
        value: RedirectProvider.NoRedirect
    },
    {
        label: "Autotrader",
        value: RedirectProvider.Autotrader
    },
    {
        label: "MotorDesk",
        value: RedirectProvider.MotorDesk
    },
    {
        label: "MotorTech",
        value: RedirectProvider.MotorTech
    },
    {
        label: "ClickDealer",
        value: RedirectProvider.ClickDealer
    }
]

export const getRedirectProviderName = (redirectProvider: RedirectProvider) => {
    const option = allRedirectProviderOptions.filter(o => o.value === redirectProvider)

    if (option && option.length === 1) {
        return option[0].label
    }

    throw new Error(`Unable to handle redirectProvider: ${redirectProvider} correctly`)
}
